/**
 * Maximum auto-logout timer value in minutes.
 * This prevents setTimeout overflow (max is 2^31-1 ms ≈ 24.8 days ≈ 35,791 minutes).
 * Capping at 35,000 minutes (≈24.3 days) provides a safe upper bound.
 */
export const MAX_AUTO_LOGOUT_MINUTES = 35000;
